/* Copyright (c) 2026 Xperi. All Rights Reserved. */

import type { FunctionComponent, JSX } from "react";

import type { ContentDescriptionProps } from "./ContentDescriptionProps";
import "./ContentDescription.scss";

/**
 * Renders a multi-line clamped description paragraph.
 *
 * Line clamping is applied via the `-webkit-line-clamp` CSS property. The
 * `maxLines` prop controls how many lines are shown before the text is clipped.
 *
 * @param props.text       - The description text to render.
 * @param props.maxLines   - Maximum number of visible lines. Defaults to `2`.
 * @param props.classStyle - Additional CSS class appended.
 */

const ContentDescription: FunctionComponent<ContentDescriptionProps> = (
  props: ContentDescriptionProps
): JSX.Element | null => {
  const TAG: string = "ContentDescription";
  const { text, classStyle = "", maxLines = 2 } = props;

  const baseClass: string =
    "content-description" + (classStyle !== "" ? " " + classStyle : "");

  const lineClampStyle: Record<string, string | number> = {
    WebkitLineClamp: maxLines
  };

  return (
    <p className={baseClass} style={lineClampStyle} data-tag={TAG}>
      {text}
    </p>
  );
};

export default ContentDescription;
